import React from 'react';
import classNames from 'classnames';

import ExternalLink from 'src/components/common/external-link';

import {
  AppRoute,
  CNAME,
  CURRENT_LOCALE,
  HEADER_PHONE,
  HEADER_PHONE_TEXT,
  IS_HEBREW,
  LOCALES,
} from 'src/constants';
import { formatHebrewPhone } from 'src/utils';

import './header.scss';

const LOGO_SIZES = {
  en: {
    medium: { width: 150, height: 34 },
    small: { width: 40, height: 40 },
  },
  he: {
    medium: { width: 110, height: 44 },
    small: { width: 24, height: 40 },
  },
};

const Header = () => {
  const { medium, small } = LOGO_SIZES[CURRENT_LOCALE];
  const withPhone = IS_HEBREW && !!HEADER_PHONE;

  const title = `${LOCALES.SEARCH_BURIAL_RECORDS}`;

  return (
    <header
      className={classNames(
        'header',
        IS_HEBREW && 'header_hebrew',
        withPhone && 'header_hebrew_with-phone'
      )}
    >
      <div className={classNames('header__wrapper', withPhone && 'header__wrapper_with-phone')}>
        <a className="header__logo-link" href={CNAME} title={title}>
          <img
            className="header__logo-img"
            alt={title}
            height={medium.height}
            src={`${process.env.PUBLIC_URL}/logos/logo-medium.svg`}
            width={medium.width}
          />
        </a>

        <a className="header__small-logo-link" href={CNAME} title={title}>
          <img
            className="header__logo-img"
            alt={title}
            height={small.height}
            src={`${process.env.PUBLIC_URL}/logos/logo-small-colored.svg`}
            width={small.width}
          />
        </a>

        {withPhone && (
          <>
            <div className="header__phone-block">
              <ExternalLink
                className="header__phone-link"
                href={`tel:${HEADER_PHONE}`}
                title={LOCALES.PHONE_NUMBER}
              >
                {formatHebrewPhone(HEADER_PHONE)}
              </ExternalLink>
              {HEADER_PHONE_TEXT && <div className="header__phone-text">{HEADER_PHONE_TEXT}</div>}
            </div>
            <div className="header__cemetery-block">
              <ExternalLink
                className="header__cemetery-link"
                href={AppRoute.ABOUT}
                title={LOCALES.CEMETERY_WEBSITE}
              >
                {LOCALES.CEMETERY_WEBSITE}
              </ExternalLink>
            </div>
          </>
        )}
      </div>
    </header>
  );
};

export default Header;
